import { DefaultTheme } from 'styled-components';

import { EIconType } from '@/components/Icon';
import { getFileFormat } from '@/utils/getFileFotmat';

export const getFileIcon = (fileName: string): EIconType => {
  const format = getFileFormat(fileName);

  switch (format) {
    case 'doc':
    case 'docx':
      return 'DocumentWordProcessor';
    case 'xls':
    case 'xlsx':
      return 'DocumentTasks';
    case 'pdf':
      return 'DocumentPdf';
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
      return 'Image';
    case 'zip':
    case 'rar':
      return 'DocumentMultiple_01';
    case 'mp4':
      return 'Video';
    default:
      return 'DocumentUnknown';
  }
};

export const getIconColor = (theme: DefaultTheme, iconName: EIconType) => {
  switch (iconName) {
    case 'DocumentPdf':
      return theme.colors.red7;
    case 'DocumentWordProcessor':
      return theme.colors.blue7;
    case 'DocumentTasks':
      return theme.colors.green8;
    default:
      return theme.colors.black6;
  }
};
